export const REGISTRATION_LOADING_ID = 'REGISTRATION_LOADING_ID'
export const SUBMIT_APPLICATION_ID = 'SUBMIT_APPLICATION_ID'
export const SIGNIN_LOADING_ID = 'SIGNIN_LOADING_ID'
export const FETCH_INDIVIDUAL_APPLICATION_ID = 'FETCH_INDIVIDUAL_APPLICATION_ID'
export const MAKING_PAYMENT_LOADING_ID = 'MAKING_PAYMENT_LOADING_ID'
export const SUBMIT_FIRM_APPLICATION_ID = 'SUBMIT_FIRM_APPLICATION_ID'
export const FETCH_APPLICATION_STATUS_ID = 'FETCH_APPLICATION_STATUS_ID'
export const FETCH_PAYMENT_STATUS_ID = 'FETCH_PAYMENT_STATUS_ID'
export const FETCH_EVENTS_LOADING_ID = 'FETCH_EVENTS_LOADING_STATUS'
export const GENERATE_BILL_LOADING_ID = 'GENERATE_BILL_LOADING_ID'
export const GENERATE_FILE_STRING_ID = 'GENERATE_FILE_STRING_ID'
export const FETCH_FIRM_APPLICATION_STATUS_ID = 'FETCH_FIRM_APPLICATION_STATUS_ID'
export const RESET_PASSWORD_LOADING_ID = 'RESET_PASSWORD_LOADING_ID'
export const CHANGE_PASSWORD_LOADING_ID = 'CHANGE_PASSWORD_LOADING_ID'
export const GENERATE_CERTIFICATE_LOADING_ID = 'GENERATE_CERTIFICATE_LOADING_ID'
export const EDIT_MEMBERSHIP_LOADING_ID = 'EDIT_MEMBERSHIP_LOADING_ID'
export const BILLER_DETAILS_LOADING_ID = 'BILLER_DETAILS_LOADING_ID'
export const FETCH_BILLERS_LOADING_ID = 'FETCH_BILLERS_LOADING_ID'
export const FETCH_PAYMENTS_LOADING_ID = 'FETCH_PAYMENTS_LOADING_ID'

